import { render, staticRenderFns } from "./ImportActionCard.vue?vue&type=template&id=d518799c&scoped=true&"
import script from "./ImportActionCard.vue?vue&type=script&lang=js&"
export * from "./ImportActionCard.vue?vue&type=script&lang=js&"
import style0 from "./ImportActionCard.vue?vue&type=style&index=0&id=d518799c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d518799c",
  null
  
)

export default component.exports